import { createFileRoute, Link } from "@tanstack/react-router";
import { Store } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { CreateOfferForm } from "./-components/CreateOfferForm";

export const Route = createFileRoute(
	"/_auth/app/_app/org/$orgId/marketplace/my-offers/new",
)({
	component: NewOfferPage,
});

function NewOfferPage() {
	const { orgId } = Route.useParams();
	const { t } = useTranslation();
	const navigate = Route.useNavigate();

	const goBack = () =>
		navigate({
			to: "/app/org/$orgId/marketplace/my-offers",
			params: { orgId },
		});

	return (
		<div className="mx-auto w-full max-w-6xl px-4 py-6 sm:px-6">
			{/* Hero header — mirrors the marketplace browse heading */}
			<div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
				<div className="flex items-center gap-3">
					<div className="grid size-11 place-items-center rounded-xl bg-primary text-primary-content shadow-sm">
						<Store className="size-6" />
					</div>
					<div>
						<h1 className="text-2xl font-bold tracking-tight">
							{t("marketplace.createOffer.title")}
						</h1>
						<p className="text-sm text-base-content/60">
							{t("marketplace.createOffer.subtitle")}
						</p>
					</div>
				</div>
				<Button asChild variant="outline" className="rounded-full">
					<Link to="/app/org/$orgId/marketplace/my-offers" params={{ orgId }}>
						{t("marketplace.myOffers.back")}
					</Link>
				</Button>
			</div>

			<CreateOfferForm orgId={orgId} onDone={goBack} onCancel={goBack} />
		</div>
	);
}
